export const I18N_FOLDER_PREFIX = `/assets/i18n/`;
export const I18N_SUFFIX = '.json';
export const DEFAULT_FALLBACK_LANG = 'en-US';
